import { getTBTSignings } from '../../../HttpRequests/tbtSignings'

export default (params = {}) => async (dispatch) => {
  dispatch({
    type: 'TBT_SIGNING_FETCH_REQUEST',
  })

  try {
    const response = await getTBTSignings(params)
    
    dispatch({
      type: 'TBT_SIGNING_FETCH_SUCCESS',
      payload: response.data,
    })
  } catch (error) {
    dispatch({
      type: 'TBT_SIGNING_FETCH_FAILURE',
      payload: error.message,
    })
  }
}
